import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import Toast from "react-bootstrap/Toast";
import {useDispatch, useSelector} from "react-redux";
import {resetErrors} from "../../actions/errorActions";

const componentName = "ErrorToast";

const ErrorToast = ({ errorParam, closeToast =()=>{}, multipleErrors, resetCurrentErrors }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const errors = useSelector((state) => state.errors);

  useEffect(() => {
    if ((errors && errors.message) || errorParam) {
      setShow(true);
    } else if (multipleErrors && multipleErrors.length) {
      setShow(true);
    }
  }, [errors, multipleErrors, errorParam]);

  const hideIt = async () => {
    await dispatch(resetErrors());
    await setShow(false);
    if(resetCurrentErrors){
       await resetCurrentErrors();
    }
    closeToast()
  };

  return (
    <Toast id={`${componentName}-errorToast`} onClose={() => hideIt()} show={show}>
      <div className="toast-header">
        <strong id={`${componentName}-errorHeader`} className="me-auto fw-bold text-danger">
          <i className="fas fa-exclamation-triangle"></i> Error
        </strong>
        <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={hideIt}></button>
      </div>
      <Toast.Body id={`${componentName}-errorText`}>
        {multipleErrors && multipleErrors.length && multipleErrors.length >0 
          ? multipleErrors.map((err) => <React.Fragment key={err}>{err}</React.Fragment>)
          : errorParam || errors.message}
      </Toast.Body>
    </Toast>
  );
};

ErrorToast.propTypes = {
  errorParam: PropTypes.string,
  closeToast: PropTypes.func,
  multipleErrors: PropTypes.arrayOf(PropTypes.string),
  resetCurrentErrors: PropTypes.func,
};

export default ErrorToast;
